import React, {useEffect, useState} from 'react'
import {Vehicle} from 'types/types.js'
import moment from 'moment'
import {P, S2, Row, IconButton} from '../UI/index.js'
import {formSpacing, DatePicker, FormRow, Input} from '../UI/forms/index.js'

interface NoteEntryProps {
    entry: Vehicle['notesEntries'][0]
    onChange: (entry: Vehicle['notesEntries'][0]) => void
    onRemove: () => void
}

const NoteEntry = ({entry, onChange, onRemove}: NoteEntryProps) => {
    const [edit, setEdit] = useState<boolean>(entry.date ? null : true)
    const [date, setDate] = useState(entry.date || moment().format('YYYY-MM-DD'))
    const [note, setNote] = useState(entry.note)
    const [hovering, setHovering] = useState(false)

    useEffect(() => {
        if (typeof edit === 'boolean' && !edit) {
            onChange({date, note})
        }
    }, [edit])

    return (
        <Row style={{width: '100%', alignItems: 'center'}} onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)}>
            {edit ?
                (
                    <FormRow style={{alignItems: 'center', marginBottom: formSpacing.rowGap}}>
                        <Input
                            label='Notitie'
                            value={note}
                            onChange={(event) => {
                                setNote(event.target.value)
                            }}
                        />

                        <FormRow gap={formSpacing.tight} style={{flex: 1}}>
                            <DatePicker
                                label='Datum'
                                value={date}
                                onChange={(event) => {
                                    if ('target' in event) {
                                        setDate(event.target.value)
                                    }
                                }}
                            />

                            <div style={{display: 'flex'}}>
                                <IconButton
                                    icon='mdi mdi-check'
                                    onClick={() => setEdit(false)}
                                />
                                <IconButton
                                    icon='mdi mdi-delete'
                                    onClick={onRemove}
                                />
                            </div>
                        </FormRow>
                    </FormRow>
                ) :
                <>
                    <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                        <P>{note}</P>
                    </Row>

                    <S2>{moment(date).format('DD-MM-YYYY')}</S2>

                    {hovering ?
                        <IconButton
                            icon='mdi mdi-pencil'
                            onClick={() => setEdit(true)}
                            style={{marginLeft: 8}}
                        /> :
                        <div style={{width: 44, height: 36}} />}
                </>
            }

        </Row>
    )
}

export default NoteEntry
